import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment MilestoneExercise on student_milestone_exercises {
    id
    exercise_id
    milestone_id
    status
    student_milestone {
      name
      id
      status
    }
    exercise {
      id
      name
      description
      duration
      blocks
      module {
        name
        id
      }
    }
    response
  }
`;

export const GET_EXERCISE = gql`
  query getExerciseDetails($id: Int!) {
    data: student_milestone_exercises(where: { id: { _eq: $id } }) {
      ...MilestoneExercise
    }
  }
  ${FRAGMENTS}
`;

export const SAVE_EXERCISE_RESPONSE = gql`
  mutation saveExercise(
    $id: Int!
    $payload: student_milestone_exercises_set_input!
    $milestoneId: Int!
    $input: student_milestones_set_input!
  ) {
    update_student_milestone_exercises(
      where: { id: { _eq: $id } }
      _set: $payload
    ) {
      returning {
        id
        status
        response
      }
    }
    update_student_milestones(
      where: { id: { _eq: $milestoneId } }
      _set: $input
    ) {
      returning {
        id
        name
        due_date
        status
        order
      }
    }
  }
`;

export const GET_SNAPSHOTS = gql`
  query getSnapshot($userId: Int!) {
    snapshots: student_milestone_exercises(
      where: {
        user_id: { _eq: $userId }
        exercise: { type: { _eq: "snapshot" } }
        response: { _neq: [] }
      }
      order_by: [{ id: asc }]
    ) {
      exercise {
        id
        name
      }
      response
    }
  }
`;

export const GET_STUDENT_EXERCISE_ID = gql`
  query getEx($userId: Int, $exerciseId: Int!) {
    data: student_milestone_exercises(
      where: { exercise_id: { _eq: $exerciseId }, user_id: { _eq: $userId } }
    ) {
      id
    }
  }
  ${FRAGMENTS}
`;
